import { map } from 'lodash';
import ProgramsDB from 'src/fb/programs-db';

export default {
  methods: {
    /**
     * Copy a program to the library by copying and adjusting content as neccessary
     */
    async copyProgramToClient(programIds, clientId, extProgramProps = {}) {
    // Load program from Firebase
      const programsDb = new ProgramsDB();

      return Promise.all(map(programIds, (programId) => {
        const programProps = {
          client: clientId,
          visibility: 'clinic',
          parentFolder: null,
          originalProgramId: programId,
          typesenseDataHash: null,
          ...extProgramProps,
        };

        const targetProps = {
          introductionDate: null,
          masteryDate: null,
          abortedDate: null,
          holdDate: null,
          currentPromptLevel: null,
          progressSettings: null,
        };

        return programsDb.duplicateProgram(programId, programProps, targetProps);
      }));
    },
  },
};
